<template>
  <v-container fill-height>
  <v-card :loading="loading" class="mx-auto my-6 pa-4" width="900" max-width="900" :elevation="0" style="border-radius:30px;">
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>

    <!-- #205295 -->
    <v-card-title class="justify-center" style="color: #000000;"><h3>{{this.lg_footer_userrequest.manageyourdatarights}}</h3></v-card-title>
    <v-card-title class="justify-center font-weight-regular mt-n6"><h6>{{this.lg_footer_userrequest.submanageyourdatarights}}</h6></v-card-title>
     <!-- <v-row class="" justify="center" >
          <v-col align="center" justify="center"  cols="12" xl="3" lg="3" md="3" sm="12" xs="12">
            <v-card-title ><h5 class="justify-center font-weight-regular mt-n4">{{this.lg_footer_userrequest.personalinformation}}</h5></v-card-title>
          </v-col>
     <v-col align="left" justify="left"  cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
          </v-col>
    </v-row> -->

    <form ref="form" @submit.prevent="sendEmail">
         <v-row class="" justify="center" >
      <v-col align="center" justify="center"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
        <!-- outlined -->
        <v-text-field
            v-model="form.firstname"
            :label="lg_footer_userrequest.placeholderfirstname"
            :placeholder="lg_footer_userrequest.placeholderfirstname"
            prepend-inner-icon="mdi-account-outline"
            dense
          ></v-text-field>
      </v-col>
      <v-col align="center" justify="center"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
        <!-- outlined -->
        <v-text-field
            v-model="form.lastname"
            :label="lg_footer_userrequest.placeholderlastname"
            :placeholder="lg_footer_userrequest.placeholderlastname"
            prepend-inner-icon="mdi-account-outline"
            dense
          ></v-text-field>
      </v-col>
       </v-row>

        <v-row class="" justify="center" >
          <!-- :hint="lg_footer_userrequest.email_hint" persistent-hint class="red-hint" -->
      <v-col align="center" justify="center" cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
       <v-text-field
            v-model="form.email"
            :label="lg_footer_userrequest.email"
            :placeholder="lg_footer_userrequest.email"
            prepend-inner-icon="mdi-email-outline"
            dense
          ></v-text-field>
      </v-col>
      <v-col align="center" justify="center" cols="12" xl="4" lg="4" md="4" sm="12" xs="12"></v-col>
       <!-- <v-col align="center" justify="center" cols="12" xl="3" lg="3" md="3" sm="12" xs="12">
       <v-text-field
            v-model="form.phone"
            :label="lg_footer_userrequest.placeholderphonenumber"
            :placeholder="lg_footer_userrequest.placeholderphonenumber"
            outlined
            dense
            :hint="lg_footer_userrequest.phone_hint"
            persistent-hint
            class="red-hint"
          ></v-text-field>
      </v-col> -->
    </v-row>

      
        <v-row class="" justify="center" >
            <v-col align="left" justify="left"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
              <h3>{{lg_footer_userrequest.request}}</h3>
            </v-col>
                <v-col align="center" justify="center"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
            </v-col>
        </v-row>

     <v-row class="mt-n4" justify="center" >
      <v-col align="center" justify="center"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
       <v-select
       v-model="form.requestType"
            :items="mDataArrayrequestType"
            :label="lg_footer_userrequest.select"
            :placeholder="lg_footer_userrequest.select"
            item-text="name"
            item-value="id"
            outlined
            dense
          ></v-select>
      </v-col>
       <v-col align="center" justify="center"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12"></v-col>
    </v-row>

    <v-row class="mt-n4" justify="center" >
            <v-col align="left" justify="left"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
              <h3>{{lg_footer_userrequest.request_details}}</h3>
            </v-col>
                <v-col align="center" justify="center"  cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
            </v-col>
        </v-row>
      <v-row class="mt-n4" justify="center" >
     <v-col align="center" justify="center" cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
       <v-textarea
       v-model="form.message"
            :label="lg_footer_userrequest.please_explain_your_request_in_detail"
            :placeholder="lg_footer_userrequest.please_explain_your_request_in_detail"
            outlined
            dense
      full-width
      single-line
    ></v-textarea>
      </v-col>
        <v-col align="center" justify="center" cols="12" xl="2" lg="2" md="2" sm="12" xs="12"></v-col>
      </v-row>

      <!-- <v-row class="ma-2" justify="center" >
          <v-col align="center" justify="center"  cols="12" xl="12" lg="12" md="12" sm="12" xs="12">
        <h4 class="justify-center font-weight-regular mt-n4">{{this.lg_footer_userrequest.detail_first_submit}}</h4>
          </v-col>
    </v-row> -->
     
      <v-card-actions class="justify-center">
        <!-- <input type="submit" :value="this.lg_footer_userrequest.submit" /> -->
        <v-btn
                type="submit"
                class="mb-1 white--text rounded-pill"
                width="300"
                height="40"
                v-bind:style="{ minWidth: 'auto', backgroundColor: '#04182D' }"
                outlined
              >
              {{
              lg_footer_userrequest.submit
            }}
              </v-btn>
      </v-card-actions>
    </form>
  </v-card>
  </v-container>
</template>

<script>
import api from "@/services/api";
import { feature } from "../services/constants";
import { lg_footer_userrequest } from "./language/lg_footer_userrequest.js";

export default {
  name: "ContactUs",
  data() {
    return {
        loading:false,
      form: {
        name: "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        requestType: "",
        message: "",
        email_to: "contact@dcm.co.th",
      },
      mDataArrayrequestType:[{id:`${this.lg_footer_userrequest.Access_information}`,name:`${this.lg_footer_userrequest.Access_information}`},
        {id:`${this.lg_footer_userrequest.Update_Information}`,name:`${this.lg_footer_userrequest.Update_Information}`},
        {id:`${this.lg_footer_userrequest.Delete_Account}`,name:`${this.lg_footer_userrequest.Delete_Account}`}
      ],
    };
  },
  methods: {
    async isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
},
    async sendEmail(e) {
        if(this.form.firstname.trim() == ""){
      this.$swal.fire(`${this.lg_footer_userrequest.check_details}`, `${this.lg_footer_userrequest.check_details_sub}`, "warning");
      return;
        }else if(this.form.lastname.trim() == ""){
      this.$swal.fire(`${this.lg_footer_userrequest.check_details}`, `${this.lg_footer_userrequest.check_details_sub}`, "warning");
      return;
        }
        else if(this.form.email.trim() == "" || await this.isValidEmail(this.form.email) == false){
    this.$swal.fire(`${this.lg_footer_userrequest.check_details}`, `${this.lg_footer_userrequest.check_details_email}`, "warning");
     return;
        }
//         else if(this.form.phone.trim() == ""){
// this.$swal.fire(`${this.lg_footer_userrequest.check_details}`, `${this.lg_footer_userrequest.check_details_sub}`, "warning");
//  return;
//         }
        else if(this.form.requestType.trim() == ""){
this.$swal.fire(`${this.lg_footer_userrequest.check_details}`, `${this.lg_footer_userrequest.check_details_sub}`, "warning");
 return;
        }else if(this.form.message.trim() == ""){
this.$swal.fire(`${this.lg_footer_userrequest.check_details}`, `${this.lg_footer_userrequest.check_details_sub}`, "warning");
 return;
        }else{

        }
        console.log(this.form);
        // return;
      try {
        this.form.name =  `${this.form.firstname} ${this.form.lastname}`
        this.$swal.showLoading();
        const response = await api.onUserRequestMyDataRightForm(this.form);
        this.$swal.close();
        if (response && response.data && response.data.status === "success") {
          this.$swal.fire("Success", response.data.message, "success");
          // Reset form field
          this.form.name = "";
          this.form.firstname = "";
          this.form.lastname = "";
          this.form.email = "";
          this.form.phone = "";
          this.form.requestType = "";
          this.form.message = "";
        } else {
          this.$swal.fire("Error", response.data.message, "error");
        }
      } catch (error) {
        console.log({ error });
        this.$swal.close();
        this.$swal.fire("Error", error.message, "error");
      }
    },
  },
  async beforeCreate() {
      this.$store.state.page_reload = false;

      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_footer_userrequest = lg_footer_userrequest.lg_footer_userrequest_th
        : this.lg_footer_userrequest = lg_footer_userrequest.lg_footer_userrequest_en;

        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
};
</script>

<style scoped>

.red-hint >>> .v-messages__message {
  color: #f44336 !important;
  font-size: 10px;
}
</style>
